import { AppEvent, AnyAppEvent } from "../appEvent.types";

const eventName = "transfer-event-ownership" as const;

export type TransferedEventOwnershipEventData = {
  eventId: string;
  newOrganiserAdminId: string;
};
export type TransferedEventOwnershipEvent = AppEvent<
  typeof eventName,
  TransferedEventOwnershipEventData
>;

export const isTransferedEventOwnershipEvent = (
  event: AnyAppEvent
): event is TransferedEventOwnershipEvent => event.name === eventName;

export { eventName as transferEventOwnership };
